var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEyeClosed = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 627.78 375.82",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9b9b9b;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.78,187.91s-140.53,155.56-313.89,155.56S0,187.91,0,187.91c0,0,140.53-155.56,313.89-155.56s313.89,155.56,313.89,155.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.89,298.46c-106.2,0-201.38-69.19-248.8-110.56,47.4-41.35,142.59-110.55,248.8-110.55s201.38,69.19,248.8,110.56c-47.4,41.35-142.59,110.55-248.8,110.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 313.89,
    cy: 187.91,
    r: 80.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.83,
    y: -32.78,
    width: 90.11,
    height: 441.37,
    transform: "translate(224.81 -166.92) rotate(45)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeClosed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye_closed.c1a414a7.svg";
export { ForwardRef as ReactComponent };